module.exports = __webpack_public_path__ + "media/images/story/icon/plus-camera-6b0e245d283438c27c16157f6b5cfcab.svg";